var exports = {
  "Lw": "overlay__dCzo_4",
  "Lx": "linkedPullRequestsList__mr03ru",
  "nb": "issueIcon__JCKl2A",
};

module.exports = exports;
